import type { FC } from 'react';

const Unsupported: FC = () => {
  return <div>File is not supported</div>;
};

export default Unsupported;
